export const HTTP_STATUSES = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
};
  
export const SERVER_INTERNAL_ERRORS = {
  LINKEDIN_PROFILE_DOES_NOT_EXIST: 11003,
};
